import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle, ArrowLeft, ShieldAlert } from 'lucide-react';
import styles from '../styles/NotFound.module.css';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className={styles.errorContainer}>
      <div className={styles.glassContent}>
        <div className={styles.iconBox}>
          <ShieldAlert size={48} color="#caa45f" />
        </div>
        <h4 className={styles.label}>TERMINAL ERROR 404</h4>
        <h1 className={styles.title}>PATH NOT <br/> <span>DEFINED.</span></h1>
        <p className={styles.description}>
          The requested architectural sector does not exist or has been moved within the Signature network.
        </p>
        <button onClick={() => navigate(-1)} className={styles.backBtn}>
          <ArrowLeft size={18} /> RETURN TO TERMINAL
        </button>
      </div>
      <div className={styles.bgBlur}></div>
    </div>
  );
}